import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PillsService {
    private filteredDataSource = new BehaviorSubject([]);
    currentFilteredData = this.filteredDataSource.asObservable();

    constructor() {}

    changeFilteredData(message: any) {
        this.filteredDataSource.next(message);
    }
}
